export * from './identity.config';
export * from './sidemenu.config';
